import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";
import connectComponent from "../../redux/connectComponent";
import Container from "components/container";
import EqualHeightPaddedRow from "components/layout/EqualHeightPaddedRow";
import { Typography } from "@material-ui/core";
import Zip from "./zip";
import Projects from "./projects";

const HeaderRow = styled.div`
  ${tw`flex flex-wrap mt-6`}
`;

const HeadingCol = styled.div`
  ${tw`w-2/3 pr-2`}
`;

const ZipCol = styled.div`
  ${tw`w-1/3 pl-2`}
`;

const InnerWrap = styled.div`
  ${tw`mx-auto`}
  max-width: 850px;
`;

const HeadingText = styled(Typography)`
  ${tw`pt-4`}
`;

export const hasGeo = () => navigator && navigator.geolocation;

const Browse = ({ actions, match, database, history }) => {
  const routePostalCode = match.params.id;
  const [fullZip, setFullzip] = useState(false);

  // URL-provided takes precedence
  const currentZip = database.authentication.currentZip() || undefined;

  // watch for url-provided zip and set flag accordingly
  useEffect(() => {
    if (currentZip && currentZip.length == 5) {
      setFullzip(true);
    }
  }, [currentZip]);

  useEffect(() => {
    if (!routePostalCode && !currentZip && hasGeo()) {
      navigator.geolocation.getCurrentPosition(
        (position) =>
          position &&
          actions.loadCurrentZip([
            position.coords.latitude,
            position.coords.longitude
          ]),
        (err) => {
          console.log("Location Error", err);
        }
      );
    }
  }, []);

  // On change of zip, redirect
  const handleZip = (zip) => history.push(`/browse/${zip}`);

  // set flag depending on zip length
  const verifyZip = (zip) => {
    if (zip.length == 5) {
      setFullzip(true);
      handleZip(zip);
    } else {
      setFullzip(false);
    }
  };

  // on new url-provided zip that originated from outside store
  useEffect(() => {
    if (routePostalCode && !currentZip) {
      actions.setCurrentZip(routePostalCode);
    }
  }, [routePostalCode, currentZip, actions]);

  return (
    <Container style={{ maxWidth: 850 }}>
      <HeaderRow>
        <HeadingCol>
          <HeadingText variant="h6">
            Restaurants coming to you {currentZip ? ` in ${currentZip}` : ""}
          </HeadingText>
        </HeadingCol>
        <ZipCol>
          <Zip onChange={verifyZip} />
        </ZipCol>
      </HeaderRow>
      <InnerWrap>
        <EqualHeightPaddedRow style={{ justifyContent: "center" }}>
          {fullZip ? (
            <Projects postalCode={currentZip} />
          ) : (
            <div>
              <HeadingText variant="h6">
                Please enter a valid zip code
              </HeadingText>
            </div>
          )}
        </EqualHeightPaddedRow>
      </InnerWrap>
    </Container>
  );
};

Browse.propTypes = {
  actions: PropTypes.object,
  match: PropTypes.object,
  database: PropTypes.object,
  history: PropTypes.object
};

export default connectComponent(Browse, ["authentication"]);
